import { render } from "./TakeSnapshot.vue?vue&type=template&id=3a10899a&scoped=true"
import script from "./TakeSnapshot.vue?vue&type=script&lang=js"
export * from "./TakeSnapshot.vue?vue&type=script&lang=js"

import "./TakeSnapshot.vue?vue&type=style&index=0&id=3a10899a&lang=less&scoped=true"

import exportComponent from "/jenkins/workspace/acs-centos7-pkg-builder/dist/rpmbuild/BUILD/cloudstack-4.19.1.2/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a10899a"]])

export default __exports__